export default class CursorManager {
	#cursors: Array<{
		cursor: string;
		id: object;
	}>;

	#element: HTMLElement;

	constructor(element: HTMLElement) {
		this.#cursors = [];
		this.#element = element;
	}

	add(cursor: string): object {
		const id = {};

		this.#cursors.push({
			cursor,
			id,
		});
		this.#setData();

		return id;
	}

	remove(id: object) {
		for (let index = 0; index < this.#cursors.length; index++) {
			if (this.#cursors[index].id === id) {
				this.#cursors.splice(index, 1);
				this.#setData();
				break;
			}
		}
	}

	update(id: object, cursor: string) {
		for (let index = 0; index < this.#cursors.length; index++) {
			if (this.#cursors[index].id === id) {
				this.#cursors[index].cursor = cursor;
				this.#setData();
				break;
			}
		}
	}

	#setData() {
		if (this.#cursors.length) { // pokud je neco ve fronte
			this.#element.style.setProperty("cursor", this.#cursors[this.#cursors.length - 1].cursor);
		} else {
			this.#element.style.removeProperty("cursor");
		}
	}
}
